import { gql } from 'graphql-tag';

/**
 * ms-report mutation that writes `status` onto the load-master documents matched by
 * jobRefId + orgId + containerId.
 *
 * `submittedAt` is intentionally left out. ms-report only honours a submitted timestamp when the
 * load-master already carries an `updatedFieldTimesMap.status` that is older than it; a load that
 * has never had a status timestamp is skipped silently. Omitting the argument takes the branch that
 * always writes and stamps the update with the server's current time.
 */
export const updateSelectedLoadMastersStatus = gql`
  mutation updateSelectedLoadMastersStatus(
    $jobRefId: String!
    $containerIds: [String!]!
    $orgId: String!
    $status: String!
  ) {
    updateSelectedLoadMastersStatus(
      jobRefId: $jobRefId
      containerIds: $containerIds
      orgId: $orgId
      status: $status
    )
  }
`;
